export var PresetEnum;
(function (PresetEnum) {
    PresetEnum["fast"] = "fast";
    PresetEnum["medium"] = "medium";
    PresetEnum["slow"] = "slow";
    PresetEnum["custom"] = "custom";
})(PresetEnum || (PresetEnum = {}));
//# sourceMappingURL=types.js.map